import React from 'react'
import { product_list } from '../Utils/dummy_data'
import Carousel from './Carousel'

const ItemTemplate = ({ data, index, start_index, display_item_num }) => {

  return (<div className={`carousel-item group ${index >= start_index && index < start_index + display_item_num ? 'visible' : ''}
${index === start_index || index === start_index + display_item_num - 1 ? '_scale-75' : ''}
`}>
    <div className={`${index === start_index ? "gradient-div-l" : index === start_index + display_item_num - 1 ? "gradient-div-r" : "hidden"}`}></div>
    <img src={data.photo} className='object-cover h-64 w-full rounded-t-md p-1' />
    <div className='bg-[#f2f2f2] p-2 uppercase font-[700] tracking-wider rounded-b-md'>
      <p>{data.name}</p>
    </div>
    <div className='absolute hidden transform transition-transform duration-[1.5s]
ease-in-out  group-hover:block left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 bg-second text-[#f2f2f2] bg-opacity-80 shadow-lg 
            px-4 border-[1px] border-black rounded-full cursor-pointer hover:border-main hover:text-main'>View Details</div>
  </div>)
}

const Products = () => {


  return (
    <div className=''>
      <h2 className='text-5xl py-20 uppercase font-bold text-main'><a href='/products'>Products</a></h2>

      <Carousel Item={ItemTemplate} display_item_num={3} itemList={product_list} paginate={true} />

      <button className=' my-4 float-right  py-2 bg-main text-[#f2f2f2] px-6 rounded-full'><a href='/products'>Learn More</a></button>
    </div>
  )
}

export default Products